import { Component } from '@angular/core';

@Component({
  selector: 'instrument-credit-check-bulk-upsert-landing',
  template: `
    <!-- <nav class="u-m-b-16">
      <ul class="breadcrumbs">
        <li>Instrument Credit Check Bulk Upload</li>
      </ul>
    </nav>
    <header class="u-m-b-40">
      <div class="row">
        <div class="columns">
          <h1 class="typography--display1">Instrument Credit Check Bulk Upload</h1>
        </div>
      </div>
    </header> -->
    <main role="main u-m-t-20">
      <div class="row">
        <div class="columns">
          <div class="card card__section">
            <p>Instrument credit check bulk upload functionality coming soon.</p>
          </div>
        </div>
      </div>
    </main>
  `
})
export class InstrumentCreditCheckBulkUpsertLandingComponent {}